import axios from 'axios';
import { retryFailedApi } from './helpers';

export const portalProtocol = async (container) => {
  const {
    companyLocation: { market },
    ref,
    scac,
    requestDetails,
  } = container;

  retryFailedApi();
  return await axios({
    method: 'post',
    url: `${process.env.VUE_APP_DOMAIN}/api/v1/turns/create/portal`,
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      authConfig: {
        email: null,
        password: null,
      },
      payload: {
        requestDetails,
        market,
        ref,
        scac,
        containers: [container],
      },
    },
  });
};
